import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import Home from "./pages/Home";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Discovery from "./pages/Discovery";
import Signup from "./pages/Signup";
import NftDetails from "./pages/NftDetails";
import Playlist from "./pages/Playlist";
import PlayMusic from "./pages/PlayMusic";
import Profile from "./pages/Profile";
import Create from "./pages/Create";

function App() {
  return (
    <Router>
      <div>
        <div style={{ position: "fixed", top: "0", zIndex: "100" }}>
          <Navbar />
        </div>

        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/discover" exact>
            <Discovery />
          </Route>
          <Route path="/signup" exact>
            <Signup />
          </Route>
          <Route path="/nftdetails/:tokenId" exact>
            <NftDetails />
          </Route>
          <Route path="/playlist" exact>
            <Playlist />
          </Route>
          <Route path="/playmusic" exact>
            <PlayMusic />
          </Route>
          <Route path="/profile" exact>
            <Profile />
          </Route>
          <Route path="/create" exact>
            <Create />
          </Route>
          <Route path="*" exact>
            {/* <Discovery /> */}
            <center>
              <div style={{ marginTop: "200px", fontSize: "120px" }}>404</div>
              <p>Page not found</p>
            </center>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
